import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/AuthContext';
import { EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import useApi from '../../../hooks/useApi';
import { ApiCallbacks, CLASSES_ENDPOINT, handleApiCall } from '../../../services/services';
import { Button, Card, Col, Divider, Empty, Form, Row, Tooltip } from 'antd';
import { InputNumberFormItem } from '../../common/InputNumberFormItem';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import { ClasseDtoB, ClasseDtoF } from '../../../services/classe';
import { prepareClasseBeforeForm } from '../../../utils/FormUtils';
import { useNavigate } from 'react-router-dom';
import { UnahtorizedAccess } from '../UnahtorizedAccess';

const MesClasses = () => {
    const { roles } = useAuth();
    const { execute } = useApi();
    const [classes, setClasses] = useState<ClasseDtoF[]>([]);
    const [form] = useForm();
    const [debutAnneeScolaire, setDebutAnneeScolaire] = useState<number>(dayjs().year());
    const navigate = useNavigate();


    async function doSearchClasses(values: any) {
        const params = { anneeDebut: values.anneeDebut, anneeFin: values.anneeFin ?? values.anneeDebut + 1 };
        const { successData: classesB } = await execute<ClasseDtoB[]>({ method: "GET", url: CLASSES_ENDPOINT, params });
        if (classesB) {
            const classesF = classesB.map(classe => prepareClasseBeforeForm(classe));
            setClasses(classesF);
        }
    }

    function getActionsClasseButtons(classe: ClasseDtoF) {
        return (
            <>
                <Tooltip title="Consulter la classe" color="geekblue">
                    <Button type="primary" icon={<EyeOutlined />} onClick={() => navigate(`/classes/${classe.id}`)} />
                </Tooltip>
            </>
        );
    }

    const getClasseView = (classe: ClasseDtoF) => {
        return (
            <Col span={6} key={"col_" + classe.id}>
                <Card className="card-focus-effect" size="small" title={classe.libelle} extra={getActionsClasseButtons(classe)} key={classe.id} bordered={false}>
                    <p><b>Enseignant: </b>{classe.nomPrenomEnseignant ?? "-"}</p>
                    <p><b>Niveau: </b>{classe.niveau}</p>
                    <p><b>Nombre d'élèves: </b>{classe.liensClasseEleves?.length ?? 0}</p>
                </Card>
            </Col>
        );
    };

    function getClassesContent() {
        return (
            <>
                <Divider orientation="left">Mes classes</Divider>
                <Row gutter={[16, 32]}>
                    {classes && classes.map((classe: ClasseDtoF) => getClasseView(classe))}
                    {classes.length === 0 && <Empty description="Aucune classe pour l'année sélectionnée" style={{ marginTop: 20 }}></Empty>}
                </Row>
            </>
        );
    }

    useEffect(() => {
        doSearchClasses({ anneeDebut: debutAnneeScolaire, anneeFin: debutAnneeScolaire + 1 });
    }, []);

    return roles?.includes("ROLE_ADMIN") || roles?.includes("ROLE_ENSEIGNANT") ? (
        <>
            <div className="centered-content">
                <div className="container-full-width">
                    <h2 className="classes-title">
                        {<EditOutlined />} Gestions de mes classes
                    </h2>
                </div>
            </div>
            <div className="main-content-classes">
                <Form form={form}
                    onFinish={doSearchClasses}
                    initialValues={{ anneeDebut: dayjs().year() }}>
                    <Row gutter={[16, 32]}>
                        <Col span={4}>
                            <InputNumberFormItem
                                name="anneeDebut"
                                label="Année scolaire"
                                rules={[{ required: true, message: "Veuillez saisir une année scolaire" }]}
                            />
                        </Col>
                        <Col span={1}>
                            <Tooltip title="Rechercher les classes" color="geekblue"><Button type="primary" htmlType="submit" icon={<SearchOutlined />} /></Tooltip>
                        </Col>
                    </Row>
                </Form>
                {getClassesContent()}
            </div>
        </>
    ) : <UnahtorizedAccess />
};

export default MesClasses;